import { useStores } from '@app/hooks'
import { useAppTranslator } from '@app/hooks/useAppTranslator'
import { observer } from 'mobx-react-lite'
import type React from 'react'
import { ContainerSimple } from '../Container'

export interface ILabelAboutProps {
  className?: string
  showPrefix?: boolean
}

const LabelAbout: React.FC<ILabelAboutProps> = props => {
  const translate = useAppTranslator({ namespaces: ['Components.LabelAbout'] })

  const { storeAbout } = useStores()

  function getVersion() {
    const productVersion = storeAbout.productVersion
    const buildLink = storeAbout.buildLink

    if (!productVersion) {
      return translate('Unknown version')
    }

    if (buildLink) {
      return (
        <a rel="noopener noreferrer" target="_blank" href={buildLink}>
          {productVersion}
        </a>
      )
    }

    return productVersion
  }

  if (props.showPrefix === true) {
    return (
      <ContainerSimple name={LabelAbout.name} className={props.className}>
        <span>
          {translate('Version')}
          {': '}
        </span>

        <ContainerSimple labelledBy="productVersion" inline>
          {getVersion()}
        </ContainerSimple>
      </ContainerSimple>
    )
  }

  return (
    <ContainerSimple
      name={LabelAbout.name}
      className={props.className}
      labelledBy="productVersion"
    >
      {getVersion()}
    </ContainerSimple>
  )
}

export default observer(LabelAbout)
